// extracted by mini-css-extract-plugin
module.exports = {"colNameRow":"index-module__colNameRow___1PXRN","reset":"index-module__reset___3nrfc","col":"index-module__col___QwZvy","arrow":"index-module__arrow___2mCNz"};